import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { doc, collection, query, where, onSnapshot } from "firebase/firestore";

export default function NewsButton({ newsFeedIcon, openModal }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [userLastRead, setUserLastRead] = useState(0);
  const uid = auth.currentUser?.uid;

  useEffect(() => {
    if (!uid) return;

    const userRef = doc(db, "Users", uid);
    const unsubscribeUser = onSnapshot(userRef, (docSnap) => {
      if (docSnap.exists()) {
        setUserLastRead(docSnap.data().userLastReadNews || 0);
      }
    }, (err) => console.error("Error reading user news timestamp:", err));

    return () => unsubscribeUser();
  }, [uid]);

  useEffect(() => {
    if (!uid) return;

    const newsRef = collection(db, "Global_News");
    const q = query(newsRef, where("timestamp", ">", userLastRead));

    const unsubscribeNews = onSnapshot(q, (snapshot) => {
      setUnreadCount(snapshot.size);
    }, (err) => console.error("Error tracking unread news count:", err));

    return () => unsubscribeNews();
  }, [uid, userLastRead]);

  const handleButtonClick = async () => {
    openModal("news");

    if (uid) {
      setUnreadCount(0);

      try {
        const token = await auth.currentUser.getIdToken(true);
        await fetch("https://marknewsasread-5dhfwyjvzq-uc.a.run.app", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });
      } catch (err) {
        console.error("Failed to sync read status to backend:", err);
      }
    }
  };

return (
  <div style={{ position: "relative", display: "inline-block" }}>
    <img 
      src={newsFeedIcon} 
      className="sidebar-icon" 
      onClick={handleButtonClick}
      style={{ cursor: "pointer", display: "block" }} 
      title="News Feed"
      alt="Open News Feed"
    />
    {unreadCount > 0 && (
      <span className="news-badge-counter">
        {unreadCount > 9 ? "9+" : unreadCount}
      </span>
    )}
  </div>
);
}